<div @fadeIn fxLayout="row" fxLayoutAlign="center start">
    <mat-card fxFlex="50">
        <mat-card-content>
            <div fxLayout="row" fxLayoutAlign="center start">
                <img class="img-style" src="assets/images/background/no-message.png">
            </div>
            <div fxLayout="row" fxLayoutAlign="center center">
                <h3>{{message}}</h3>
            </div>
        </mat-card-content>
    </mat-card>
</div>